import gql from 'graphql-tag';

const GET_TRANSLATIONS = gql`
  query GetTranslations {
    getTranslations {
      translations {
        id
        key
        translation
        language
      }
    }
  }
`;

export default {
  GET_TRANSLATIONS,
};
